import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fbb171c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ag-page_config position-relative" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "row p-4" }
const _hoisted_4 = { class: "col-md-4 customFilterRow" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ag-background_grey w-100 text-center p-2" }, "Category", -1))
const _hoisted_6 = {
  class: "",
  style: {"padding":"8px 12px","background":"#edf0f1"}
}
const _hoisted_7 = ["value", "title"]
const _hoisted_8 = { class: "col-md-4 customFilterRow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ag-background_grey w-100 text-center p-2" }, "Conditions", -1))
const _hoisted_10 = {
  class: "d-flex justify-content-center ag-background_boxgrey h-75 p-2",
  style: {"flex-direction":"column"}
}
const _hoisted_11 = ["title"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 1,
  class: "slider-container"
}
const _hoisted_15 = { class: "slider-track" }
const _hoisted_16 = ["onUpdate:modelValue", "max", "onInput"]
const _hoisted_17 = ["onUpdate:modelValue", "checked"]
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { class: "col-md-4 customFilterRow" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ag-background_grey w-100 text-center p-2" }, "Action", -1))
const _hoisted_21 = { class: "d-flex justify-content-between ag-background_boxgrey h-75 p-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group form-check w-50" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Send emails")
], -1))
const _hoisted_23 = { class: "col-md-12 mt-4" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_loading = _resolveComponent("ag-loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ag_card = _resolveComponent("ag-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ag_loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ag_card, {
        module: _ctx.module.card1
      }, {
        "deployment-health-alerts": _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  class: "custom-select",
                  size: "5",
                  id: "target",
                  style: {"min-height":"120px","padding":"0.5rem","border":"0px","width":"100%"},
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newAlertJson.selectedAlert) = $event)),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAlert($event)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item, key) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: item.id,
                      title: item.title,
                      style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
                    }, _toDisplayString(item.title), 9, _hoisted_7))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.newAlertJson.selectedAlert]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentConditions, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex align-items-center justify-content-center ag-background_boxgrey mb-3",
                    key: index
                  }, [
                    _createElementVNode("span", {
                      class: "mr-2 text-truncate d-inline-block",
                      style: {"max-width":"150px","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"},
                      "data-bs-toggle": 'tooltip',
                      "data-bs-placement": 'top',
                      title: item.Label
                    }, _toDisplayString(item.Label), 9, _hoisted_11),
                    (item.Field == 'SelectBox')
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => ((item.DefaultValue) = $event),
                          class: "form-control form-control-sm",
                          style: {"width":"140px"}
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Options, (opt, optkey) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: optkey,
                              value: opt.value || opt
                            }, _toDisplayString(opt.label || opt), 9, _hoisted_13))
                          }), 128))
                        ], 8, _hoisted_12)), [
                          [_vModelSelect, item.DefaultValue]
                        ])
                      : _createCommentVNode("", true),
                    (item.Field == 'Slider')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", {
                              class: "slider-progress",
                              style: _normalizeStyle({ width: _ctx.tooltipPosition + '%' })
                            }, null, 4)
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "range",
                            "onUpdate:modelValue": ($event: any) => ((item.DefaultValue) = $event),
                            min: 0,
                            max: item.MaxValue,
                            class: "slider",
                            onInput: ($event: any) => (_ctx.updateTooltipPosition(item.DefaultValue))
                          }, null, 40, _hoisted_16), [
                            [_vModelText, item.DefaultValue]
                          ]),
                          _createElementVNode("div", {
                            class: "tooltip-style",
                            style: _normalizeStyle({ left: _ctx.tooltipPosition + '%' })
                          }, _toDisplayString(item.DefaultValue), 5)
                        ]))
                      : _createCommentVNode("", true),
                    (item.Field == 'CheckBox')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 2,
                          "onUpdate:modelValue": ($event: any) => ((item.DefaultValue) = $event),
                          checked: item.DefaultValue,
                          type: "checkbox"
                        }, null, 8, _hoisted_17)), [
                          [_vModelCheckbox, item.DefaultValue]
                        ])
                      : _createCommentVNode("", true),
                    (item.Field == 'TextBox')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 3,
                          "onUpdate:modelValue": ($event: any) => ((item.DefaultValue) = $event),
                          type: "text",
                          maxlength: "191"
                        }, null, 8, _hoisted_18)), [
                          [_vModelText, item.DefaultValue]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                (_openBlock(), _createBlock(_component_Multiselect, {
                  modelValue: _ctx.emails,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emails) = $event)),
                  mode: "tags",
                  "close-on-select": true,
                  searchable: true,
                  key: _ctx.compKey,
                  "create-tag": true,
                  "add-option-on": "'enter'|'space'|'tab'|';'|','",
                  "add-tag-on": "'enter'|'space'|'tab'|';'|','",
                  "append-new-tag": true,
                  "create-option": true,
                  onTag: _ctx.handleTagCreate,
                  "filter-results": false,
                  options: _ctx.emails
                }, null, 8, ["modelValue", "onTag", "options"]))
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_ctx.isEditing())
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ag-button border-0 ag-button_primary ag-button_radius float-right pr-5 pl-5 ml-2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addOrUpdateAlert(false))),
                    disabled: _ctx.emails.length === 0
                  }, " Save Alert ", 8, _hoisted_24))
                : _createCommentVNode("", true),
              (_ctx.currentConditions && !_ctx.isEditing())
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "ag-button border-0 ag-button_primary ag-button_radius float-right pr-5 pl-5 ml-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addOrUpdateAlert())),
                    disabled: _ctx.emails.length === 0
                  }, " Add Alert ", 8, _hoisted_25))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["module"]),
      _createVNode(_component_ag_card, {
        class: "custom-card",
        module: _ctx.module.deploymentHealthAlerts
      }, null, 8, ["module"])
    ])
  ]))
}